import APIService from '../base'
import type { CommonPagination } from '@/types/common'
import type { PromotionItem, PromotionQueryParams } from '@/types/promotion'
import type { AxiosResponse } from 'axios'

export class PromotionService {
  static getList(
    params: PromotionQueryParams,
  ): Promise<AxiosResponse<CommonPagination<PromotionItem>>> {
    return APIService.get('/v1/admin/promotions', { params })
  }

  static getById(id: string): Promise<AxiosResponse<PromotionItem>> {
    return APIService.get(`/v1/admin/promotions/${id}`)
  }

  static create(
    payload: Partial<PromotionItem>[],
  ): Promise<AxiosResponse<PromotionItem>> {
    return APIService.post('/v1/admin/promotions/bulk', payload)
  }

  static update(payload: Partial<PromotionItem>, id: string): Promise<void> {
    return APIService.patch(`/v1/admin/promotions/${id}`, payload)
  }

  static delete(id: string): Promise<void> {
    return APIService.delete(`/v1/admin/promotions/bulk`, {
      data: { ids: [id] },
    })
  }
}
